/**
 * This component should always be lazy-loaded.
 */
export const loadWithinAppLayoutRoutesChunk = () => {
  return import('./WithinAppLayoutRoutes');
};
